import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-azure-oauth-response',
  templateUrl: './azure-oauth-response.component.html',
  styleUrls: ['./azure-oauth-response.component.css']
})
export class AzureOauthResponseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
